import React, { FC } from "react";
import Form from "react-bootstrap/Form";
import TextField from "@mui/material/TextField";

interface IInputTextArea {
  controlId: string;
  label: string;
  placeholder: string;
  handleChange: any;
  handleBlur: any;
  errorsField: any;
  autofocus?: any;
  touched: any;
  value: any;
  focused?: boolean;
}

/**
 * Input Type Text Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; }} {
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched
}
 * @returns {*}
 */
const InputTextArea: FC<IInputTextArea> = ({
  controlId,
  label,
  placeholder,
  handleChange,
  handleBlur,
  errorsField,
  touched,
  value,
  autofocus,
  focused,
}) => {
  return (
    <>
      <TextField
        autoFocus={autofocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        defaultValue={value}
        value={value}
        onChange={handleChange}
        multiline
        rows={3}
        error={errorsField && touched}
        label={label}
        helperText={errorsField && touched ? errorsField : ""}
        name={controlId}
        focused={focused}
        // readOnly={readOnly}
        // disabled={disabled}
      />

      {/* <Form.Group className="mb-3 pb-1" controlId={controlId}>
            <Form.Label className="mb-1 text-uppercase fs-11 fw-bold label-color ls-small">{label}</Form.Label>
            <div className="position-relative">
                <Form.Control value={value} as="textarea" rows={3} placeholder={placeholder} onBlur={handleBlur} onChange={handleChange} isInvalid={!!errorsField && touched} />
                <Form.Control.Feedback type="invalid">
                    {errorsField}
                </Form.Control.Feedback>
            </div>
        </Form.Group>*/}
    </>
  );
};

export default InputTextArea;
